import styled from "styled-components";
import { ITeachingBubbleStyles } from "@fluentui/react";

export const GuideHeader = styled.div`
    cursor: default;
`;

export const GuideHeaderTitle = styled.h3`
    display: inline;
    vertical-align: middle;
    margin-left: 5px;
    cursor: default;
`;

export const GuideTipStep = styled.div<{$isVisible: boolean}>`
    transition: all 0.5s ease-in-out 0s;
    opacity: ${(props) => props.$isVisible ? 1 : 0};
    ${(props) => !props.$isVisible &&
    `
        display: inline-block !important;
        height: 0;
        width: 0;
        overflow: hidden;
    `}
    cursor: default;
`;

export const GuideTipImage = styled.img`
    margin: 5px 0;
    width: 100%;
`;

export const GuideTipTitle = styled.h4`
    cursor: default;
`;

export const GuideTipParagraph = styled.p`
    margin: 5px 0;
    cursor: default;
    text-align: justify;
    text-justify: inter-word;
    hyphens: auto;
    line-height: 1.45;
`;

export const GuideBubbleFluentStyles: Partial<ITeachingBubbleStyles> =
{
    bodyContent:
    {
        '.ms-Icon': {color: '#555 !important'}
    },
    body:
    {
        background: 'white',
        marginRight: '0'
    },
    subText:
    {
        color: '#555 !important',
        'p': { margin: '5px 0' }
    },
    footer:
    {
        color: '#555 !important'
    }
};